module.exports = __webpack_public_path__ + "assets/img/android-portrait1.14f9a66.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/android-portrait1.png
// module id = fb+S
// module chunks = 50